// ⭐ สรุปทิศของ order ที่ยอดสลิปไม่ตรง (amount_mismatch) — ใช้ร่วม OrdersPage / AllOrdersPage / PayoutTopupsPage
// ทิศดูจากเครื่องหมาย slip_amount − requested_amount: เกิน (overpay) หรือ ขาด (underpay)
export function slipMismatchInfo(o: { slip_amount?: number | null; requested_amount?: number | null }) {
  const delta = (o.slip_amount ?? 0) - (o.requested_amount ?? 0);
  const over = delta >= 0;
  return {
    over,
    absDelta: Math.abs(delta),
    badge: over ? 'ยอดเกิน' : 'ยอดขาด',
    word: over ? 'เกิน' : 'ขาด',
  };
}
